<template>
  <div class="def-labels-tags-modal">
    <ModalAsideHeader>
      {{ result.name }}
    </ModalAsideHeader>
    <ModalAsideBody>
      <DefContent v-html="result.text"></DefContent>
    </ModalAsideBody>
  </div>
</template>

<script lang="ts" setup>
import ModalAsideHeader from '@use/useModalAside/ModalAsideHeader.vue';
import ModalAsideBody from '@use/useModalAside/ModalAsideBody.vue';
import { IProductLabel } from '@/storePinia/interfaces/IProduct/IProduct';
import DefContent from '@components/Def/DefContent/DefContent.vue';

const props = defineProps<{ result: IProductLabel }>();
</script>

<style lang="scss" scoped>
.def-labels-tags-modal {
}
</style>
